export default "__VITE_ASSET__DbSFTIiJ__"